module.exports = __webpack_public_path__ + "img/history-clock-button.4979f1bf.svg";